import { useEffect } from 'react';
import { useSession } from '../../session';
import { useOnAfterRouteChange } from '../../routing';
export var usePageviewTracker = function (_a) {
    var trackPageView = _a.trackPageView, trackLogout = _a.trackLogout;
    var session = useSession().data;
    useEffect(function () {
        trackPageView();
    }, []);
    useOnAfterRouteChange(function (nextRoute) {
        if (nextRoute.pathname === '/sign-out') {
            if (trackLogout) {
                trackLogout();
            }
            return;
        }
        trackPageView();
    }, [session]);
};
